<template>
  <div class="wrapper">
  <!-- <div class="home-wrapper"> -->
    <!-- <div class="view-row"> -->
      <!-- <el-card class="box-card" style="display:flex;flex:1;">
        <div style="height:400px;"></div>
      </el-card> -->
      <common-card :gutter="6" title="系统首页">
        <el-col :span="24">
          <el-button type="primary" @click.stop="guide">功能指引</el-button>
        </el-col>
      </common-card>
      <!-- <el-card class="box-card">
        <div id="myChart1" :style="{ width: '400px', height: '400px' }"></div>
      </el-card>
      <el-card class="box-card">
        <div id="myChart2" :style="{ width: '400px', height: '500px' }"></div>
      </el-card>-->
    
    <!-- </div> -->
  <!-- </div> -->
  </div>
</template>

<script>
import driver from "@/mixins/startDriver";
// const chartOption1 = {
//   title: { text: "访问统计柱状图", left: "center", bottom: 0 },
//   tooltip: {},
//   xAxis: {
//     data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
//   },
//   yAxis: {},
//   series: [
//     {
//       name: "销量",
//       type: "bar",
//       data: [5, 20, 36, 10, 10, 20]
//     }
//   ]
// };
// const chartOption2 = {
//   title: {
//     text: "访问统计饼状图",
//     subtext: "虚构数据",
//     left: "center",
//     bottom: 30
//   },
//   tooltip: {
//     trigger: "item",
//     formatter: "{a} <br/>{b} : {c} ({d}%)"
//   },
//   legend: {
//     // orient: 'vertical',
//     // top: 'middle',
//     bottom: 0,
//     left: "center",
//     data: ["西凉", "益州", "兖州", "荆州", "幽州"]
//   },
//   series: [
//     {
//       type: "pie",
//       radius: "65%",
//       center: ["50%", "50%"],
//       selectedMode: "single",
//       data: [
//         {
//           value: 1548,
//           name: "幽州"
//         },
//         { value: 535, name: "荆州" },
//         { value: 510, name: "兖州" },
//         { value: 634, name: "益州" },
//         { value: 735, name: "西凉" }
//       ],
//       itemStyle: {
//         emphasis: {
//           shadowBlur: 10,
//           shadowOffsetX: 0,
//           shadowColor: "rgba(0, 0, 0, 0.5)"
//         }
//       }
//     }
//   ]
// };
export default {
  mixins: [driver],
  data() {
    return {
      menuList :[], //权限数组
    };
  },
  mounted() {
    // this.drawLine("myChart1", chartOption1);
    // this.drawLine("myChart2", chartOption2);
    let activeIndex = sessionStorage.getItem("activeIndex");
    if(activeIndex=='1-1' | null){
      // 首次进入 自动跳转
      let id = JSON.parse(sessionStorage.getItem("userinfo")).id
      this.$http({
        url: this.$api.permissionuser + id,
        method: "GET",
      }).then(res => {
        if (res.data.code == 200) {
          this.menuList = res.data.data.permissions;//权限 路由
          let routerpath = this.menuList[0].urlPath;//默认取第一个权限作为展示页
          this.$router.push(routerpath);//home页面做一次跳转
        }
      });
      
    }else{
      // 不是首次进入
      return false
    }
     
  },

   

  methods: {
    //   drawLine(Chart, options) {
    //     // 基于准备好的dom，初始化echarts实例
    //     let myChart = this.$echarts.init(document.getElementById(Chart));
    //     // 绘制图表
    //     myChart.setOption(options);
    //   }
  }
};
</script>

<style lang="scss">
.box-card {
  margin: 10px;
}
.view-row {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
}
</style>
